import { useCallback, useEffect } from 'react';
import { Metrics } from 'customer-data-objects/metrics/Metrics';
export const useAutosaveWindowEvents = getHasInFlightSaves => {
  const handleBeforeUnload = useCallback(e => {
    if (getHasInFlightSaves()) {
      Metrics.counter('autosave-saving-and-beforeunload').increment();
      e.preventDefault();
      e.returnValue = true;
    }
  }, [getHasInFlightSaves]);
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload]);
};